<template>
    <base-container>
        <!-- <van-nav-bar title="当日挂号"></van-nav-bar> -->
        <div class="artisan-top-container">
            <div class="artisan-center" style="color:#1476FE;">
                <van-icon size="3rem" name="checked" />
                <br />
                <br />
                <b>当日挂号成功</b>
            </div>
            <br />
            <p class="artisan-center" style="padding-bottom: 10px;"><b style="font-size:1.3rem;">¥</b>&nbsp;<b
                    style="font-size:2rem;" v-text="registerConfirmationInfo.payAmount.toFixed(2)"></b></p>
            <div>
                <van-cell style="background:#f7f8fa" title="卡号" :value="registerConfirmationInfo.cardNo">
                    <template #title>
                        <span style="color:grey;font-size:0.9rem">卡号</span>
                    </template>
                    <b style="color:black;font-size:1rem" v-text="registerConfirmationInfo.cardNo"></b>
                </van-cell>
                <van-cell style="background:#f7f8fa" title="病历号" :value="registerConfirmationInfo.medRecoNo">
                    <template #title>
                        <span style="color:grey;font-size:0.9rem">病历号</span>
                    </template>
                    <b style="color:black;font-size:1rem" v-text="registerConfirmationInfo.medRecoNo"></b>
                </van-cell>
                <van-cell style="background:#f7f8fa" title="医院"
                    :value="registerConfirmationInfo.hosName - registerConfirmationInfo.hosAreaName">
                    <template #title>
                        <span style="color:grey;font-size:0.9rem">医院</span>
                    </template>
                    <b style="color:black;font-size:1rem">{{registerConfirmationInfo.hosName}}-{{registerConfirmationInfo.hosAreaName}}</b>
                </van-cell>
                <van-cell style="background:#f7f8fa" title="号别" :value="registerConfirmationInfo.noTypeName">
                    <template #title>
                        <span style="color:grey;font-size:0.9rem">号别</span>
                    </template>
                    <b style="color:black;font-size:1rem" v-text="registerConfirmationInfo.noTypeName"></b>
                </van-cell>
                <van-cell style="background:#f7f8fa" title="挂号科室" :value="registerConfirmationInfo.deptName">
                    <template #title>
                        <span style="color:grey;font-size:0.9rem">挂号科室</span>
                    </template>
                    <b style="color:black;font-size:1rem" v-text="registerConfirmationInfo.deptName"></b>
                </van-cell>
                <van-cell v-if="registerConfirmationInfo.doctorName!=''" style="background:#f7f8fa" title="挂号医生"
                    :value="registerConfirmationInfo.doctorName">
                    <template #title>
                        <span style="color:grey;font-size:0.9rem">挂号医生</span>
                    </template>
                    <b style="color:black;font-size:1rem" v-text="registerConfirmationInfo.doctorName"></b>
                </van-cell>
                <van-cell style="background:#f7f8fa" title="日期"
                    :value="moment(registerConfirmationInfo.visitDate).format('YYYY年MM月DD日')">
                    <template #title>
                        <span style="color:grey;font-size:0.9rem">日期</span>
                    </template>
                    <b style="color:black;font-size:1rem"
                        v-text="moment(registerConfirmationInfo.visitDate).format('YYYY年MM月DD日')"></b>
                </van-cell>
                <van-cell style="background:#f7f8fa" title="时段"
                    :value="registerConfirmationInfo.visitWeek - registerConfirmationInfo.visitTime">
                    <template #title>
                        <span style="color:grey;font-size:0.9rem">时段</span>
                    </template>
                    <b style="color:black;font-size:1rem">{{registerConfirmationInfo.visitWeek}}
                        {{registerConfirmationInfo.visitTime}}</b>
                </van-cell>
            </div>
            <van-button class="artisan-btn" type="info" block round to="/">回首页</van-button>
        </div>
    </base-container>
</template>

<script>
    import { isLogin } from "@/util/auth";
    import { getUserInfo } from "@/api/customer";
    import { queryPay } from "@/api/order";
    import moment from "moment";
    export default {
        props: ["billNo"],
        data() {
            return {
                isLoading: false,
                user: {
                    cusWaterfeeInfos: [],
                    cusMedicalCards: [],
                },//患者信息集合
                isLogin: false,//是否已登录系统
                orderInfo: {
                    payAmount: 0,
                    billNo: "",//系统订单号-平台返回
                    isPay: false
                },//订单信息
                registerConfirmationInfo: {
                    noTypeName: ""
                },//业务数据集合
                hisResRegConfirmInfo: {}
            }
        },
        created() {
            if (this.$route.params.billNo != undefined) {
                this.orderInfo.billNo = this.$route.params.billNo;
                queryPay(this.orderInfo.billNo).then(res => {
                    if (res.data.value != null) {
                        this.registerConfirmationInfo = res.data.value.registerInfo;
                        if (this.registerConfirmationInfo.noType == "0") {
                            this.registerConfirmationInfo.noTypeName = "普号";
                        }
                        else {
                            this.registerConfirmationInfo.noTypeName = "专家号";
                        }
                        this.orderInfo.isPay = res.data.value.isPay;
                        this.orderInfo.payAmount = res.data.value.amount;

                    }
                });
            }
            if (isLogin()) {
                this.isLogin = true;
                this.getUserInfo();
            }
        },
        methods: {
            moment,
            getUserInfo() {
                this.isLoading = true;
                getUserInfo().then(res => {
                    //console.log(res.data.value);
                    if (res.data.value != null) {
                        this.user = res.data.value;
                        if (this.user.cusMedicalCards.length > 0) {
                            this.checkUsesMedInfo = this.user.cusMedicalCards[0];
                        }
                    }
                    this.isLoading = false;
                });
            }
        }
    }
</script>
<style>
    .custom-image .van-empty__image {
        width: 90px;
        height: 90px;
    }
</style>